export default "__VITE_ASSET__ChOfBm8b__"